import { newConfig } from '../config';
import config from '../config';
import { AppError } from '@/utils/error';

const appConfig = config();
const { v2 } = appConfig.apiVersion;
const employeesBaseUrl = `${newConfig.services.proxy.url}${newConfig.services.proxy.core}/${v2}/employees`;
const employeeOverviewUrl = (rut) =>
  `${employeesBaseUrl}/${encodeURIComponent(rut)}/overview`;

export default class EmployeeService {
  constructor(client) {
    this.client = client;
  }

  normalizeEmployees(payload) {
    if (Array.isArray(payload)) {
      return payload;
    }

    return payload ? [payload] : [];
  }

  getFirstEmployee(payload, rut) {
    const [employee] = this.normalizeEmployees(payload);

    if (!employee) {
      throw new AppError(`No se encontró el empleado con RUT ${rut}`);
    }

    return employee;
  }

  normalizeEmployeeOverview(payload, rut) {
    const overview = this.getFirstEmployee(payload, rut);

    if (
      overview.employee ||
      overview.companies ||
      overview.insuranceCompanies ||
      overview.coverages ||
      overview.tickets
    ) {
      return {
        ...overview,
        employee: overview.employee ?? {},
        companies: overview.companies ?? [],
        insuranceCompanies: overview.insuranceCompanies ?? [],
        coverages: overview.coverages ?? [],
        tickets: overview.tickets ?? []
      };
    }

    return {
      employee: overview,
      companies: overview.companies ?? [],
      insuranceCompanies: overview.insuranceCompanies ?? [],
      coverages: overview.coverages ?? [],
      tickets: overview.tickets ?? []
    };
  }

  async getEmployees({ rut }) {
    const response = await this.client.get(employeesBaseUrl, { params: { rut } });
    return response.data;
  }

  async getEmployee({ rut }) {
    const employees = await this.getEmployees({ rut });
    const employee = this.getFirstEmployee(employees, rut);
    return employee.employee ?? employee;
  }

  async getEmployeeOverview({ rut }) {
    const response = await this.client.get(employeeOverviewUrl(rut));
    return this.normalizeEmployeeOverview(response.data, rut);
  }
}
